import {
  ProfileModel,
  StatusModel,
  SkillModel,
  OtherModel,
  BackStoryModel,
  JobPointFormula,
} from '@/model/charactersheets';
import { csInitial } from './initial';

export const actions = {
  updateGameSystem: ({ commit }, gamesystem: number) => {
    commit('setGameSystem', gamesystem);
  },
  updateProfile: ({ commit }, profile: ProfileModel) => {
    commit('setProfile', profile);
  },
  updateStatus: ({ commit }, status: StatusModel) => {
    commit('setStatus', status);
  },
  updateSkill: ({ commit }, skill: SkillModel) => {
    commit('setSkill', skill);
  },
  addSkill: ({ commit }, skill: SkillModel) => {
    commit('addedSkill', skill);
  },
  updateOther: ({ commit }, other: OtherModel) => {
    commit('setOther', other);
  },
  updateBackStory: ({ commit }, backStory: BackStoryModel) => {
    commit('setBackStory', backStory);
  },
  updateUid: ({ commit }, uid: string) => {
    commit('setUid', uid);
  },
  updatePrivate: ({ commit }, isPrivate: boolean) => {
    commit('setPrivate', isPrivate);
  },
  updateSkillList: ({ commit }, skillList: SkillModel[]) => {
    commit('setSkillList', skillList);
  },
  updateJobPointFormula: ({ commit }, formula: JobPointFormula) => {
    commit('setJobPointFormula', formula);
  },
  initialize: ({ commit }) => {
    commit('setGameSystem', csInitial.gamesystem);
    commit('setProfile', csInitial.profile);
    commit('setStatus', csInitial.status);
    commit('setSkill', csInitial.skill);
    commit('setOther', csInitial.other);
    commit('setBackStory', csInitial.backStory);
    commit('setUid', csInitial.uid);
    commit('setPrivate', csInitial.isPrivate);
  },
};
